import Color from '../Color.mjs'
import superMeta from '../_PRODUCT/metaProductNode.mjs'

export default {
    ...superMeta,
    themeColor: Color.LIGHT_ORANGE,
    codeProp: 'aiCode',
    detailUrl: '/AmAiDetail',
    detailIdProp: 'aiId',
    listUrl: '/AmAiList',
    mapProp: 'aiMap',
    name: '分析指标',
    textProp: 'aiName',
    type: 'AMAI',
}
